import {TicketVo} from '../../common/shared/api/gateway/TicketVo.interface';
import {TicketSum} from '../generated/types';
import {createTicketKind} from './TicketKind';
import {createTicketType} from './TicketType';

export function createTicketSum({
  ticket_type,
  ticket_count,
  ticket_expire_at,
}: TicketVo): TicketSum {
  return {
    ticketType: createTicketType(ticket_type),
    ticketKind: createTicketKind(ticket_type),
    count: ticket_count,
    ticketExpireAt: ticket_expire_at,
  };
}
